import React from "react";
import fb from '../../lib/firebase';
import {VeterinarioObject} from "../../models/Veterinario";
import FieldView from "../../components/FieldView";
import FormVeterinario from "./FormVeterinarioHOC";
import {formDef} from "./FormVeterinarioHOC";
import EntityView from "../../components/EntityView";
import {IonProgressBar} from "@ionic/react";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import {dataInCurrentMonth} from "../../lib/utils";

interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: VeterinarioObject;
  goBack: () => void;
  loading: boolean;
}

interface State {
  allowDelete: boolean;
}

class AbaVeterinario extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      allowDelete: dataInCurrentMonth(props.instance.criado_em.toDate()),
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.instance.criado_em !== this.props.instance.criado_em) {
      this.setState({allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate())});
    }
  }

  onDelete = () => {
    fb.db.collection('veterinarios').doc(this.props.instance.id).delete()
      .then(() => {
        this.props.dispatch(actions.notifySuccess('Veterinário excluído com sucesso.'));
        this.props.goBack();
      });
  };

  render() {
    const {instance} = this.props;

    if (this.props.loading)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <EntityView
        instance={instance}
        ModelForm={FormVeterinario}
        entityLabel="Veterinário"
        gender="m"
        allowDelete={this.state.allowDelete}
        onDelete={this.onDelete}
      >
        {
          instance &&
          <>
            <FieldView def={formDef.nome} value={instance.nome} className="text-2xl"/>

            {
              instance.tipo === 'Outro' ?
                <FieldView label="Tipo" value={instance.tipo_outro}/> :
                <FieldView label="Tipo" value={instance.tipo}/>
            }

            <div className="flex flex-wrap">
              <div className="w-8/12">
                <FieldView def={formDef.cidade} value={instance.cidade}/>
              </div>
              <div className="w-4/12">
                <FieldView def={formDef.estado} value={instance.estado}/>
              </div>
            </div>

            {
              instance.telefone &&
              <FieldView def={formDef.telefone} value={instance.telefone}/>
            }
            {
              instance.email &&
              <FieldView def={formDef.email} value={instance.email}/>
            }

            {
              instance.aniversario &&
              <FieldView def={formDef.aniversario} value={instance.aniversario}
                         format="DD/MM"

              />
            }

            <div className="flex flex-wrap">
              <div className="w-8/12">
                <FieldView def={formDef.endereco} value={instance.endereco}/>
              </div>
              <div className="w-4/12">
                <FieldView def={formDef.complemento} value={instance.complemento}/>
              </div>
            </div>

            <FieldView def={formDef.cep} value={instance.cep}/>

            <div className="app-modelview-section-title">
              Informações adicionais
            </div>

            <FieldView def={formDef.area_atuacao} value={instance.area_atuacao}/>

            <FieldView def={formDef.ramo_atuacao} value={instance.ramo_atuacao}/>

            {
              instance.ramo_atuacao.indexOf('Outro') !== -1 &&
              <FieldView def={formDef.ramo_atuacao_outro} value={instance.ramo_atuacao_outro}/>
            }

            <FieldView def={formDef.propriedades_atendidas_mes}
                       value={instance.propriedades_atendidas_mes}/>
            <FieldView def={formDef.vacas_iatf_ano}
                       value={instance.vacas_iatf_ano}/>

            <div className="app-modelview-section-title">
              Produtos Virbac
            </div>

            <FieldView def={formDef.conhece_linha_virbac}
                       value={instance.conhece_linha_virbac}/>
            <FieldView def={formDef.ja_usou_produto_virbac}
                       value={instance.ja_usou_produto_virbac}/>
            <FieldView def={formDef.usou_bovigen_repro_total}
                       value={instance.usou_bovigen_repro_total}/>
            <FieldView def={formDef.usou_bovigen_lepto8}
                       value={instance.usou_bovigen_lepto8}/>
            <FieldView def={formDef.usou_bovigen_v4j5}
                       value={instance.usou_bovigen_v4j5}/>
            <FieldView def={formDef.usou_fosfosal}
                       value={instance.usou_fosfosal}/>
          </>
        }
      </EntityView>
    )
  }
}

export default connect(({app}: RootState) => ({app}))(AbaVeterinario);